import * as React from 'react';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { toAbsoluteUrl } from 'app/infrastructure/hosting';
import { Icon } from 'ui/common/icon';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComponentProps } from 'ui/common';

interface FactItemConnectedCasesProps extends ComponentProps, FactItemProps {
  connectedCasesIds: number[];
}

export const ConnectedCasesFactItem = (props: FactItemConnectedCasesProps) => {
  const { tooltip, title, connectedCasesIds, url, linkDomain, portalTarget } = props;
  const iconAbsolutePath = toAbsoluteUrl('i/connected-cases.svg');
  const iconConnectedCases = <Icon url={iconAbsolutePath} />;
  const items = [
    { value: connectedCasesIds?.length, tooltip }
  ];

  if (!connectedCasesIds?.length) {
    return null;
  }  

  return <FactLink id={props.componentId} classNames="fact-item" section={linkDomain} url={url}>
    <BadgeList
      icon={iconConnectedCases}
      title={title}
      valueItems={items}
      portalTarget={portalTarget}
    />
  </FactLink>;
};
